/**
 * ======================= DONEM KIYASI ("gecen doneme gore") ==================
 *
 * Ozet ve Rapor ekranlarindaki yon oklari buradan uretilir.
 *
 * KIYAS SUNUCUDA DEGIL ISTEMCIDE. Her iki uc da tarih araligi aldigi icin
 * onceki donem, secili araligin HEMEN ONCESINDEKI ve AYNI UZUNLUKTAKI pencere
 * olarak ikinci bir istekle cekiliyor. Sunucu degisikligi gerektirmemesinin
 * sebebi bu — mobil de (dovizhub-mobile/src/shared/utils/trend.ts) ayni yolu
 * izliyor ve iki istemcinin ayni sayiyi gostermesi bunun kosulu.
 * ========================================================================== */

/**
 * Yuzde degisim.
 *
 * ONCEKI DONEM 0 ISE `null` DONER, `Infinity` ya da `%100` DEGIL. Sifirdan
 * herhangi bir sayiya cikisin yuzdesi tanimsizdir; "%∞ artti" ya da uydurma
 * bir "%100" gostermek yerine rozet hic cizilmez (TrendBadge null'da null
 * dondurur). Kullaniciya yanlis bir buyukluk vermektense hic vermemek dogru.
 *
 * Negatif `previous` de ayni sekilde elenir: bu alanlarda negatif bir onceki
 * donem anlamsiz ve boleni negatif yapmak isareti ters cevirirdi.
 */
export const trendDelta = (current: number, previous: number): number | null => {
  if (!Number.isFinite(previous) || previous <= 0) return null;
  if (!Number.isFinite(current)) return null;
  return Math.round(((current - previous) / previous) * 100);
};

/**
 * Secili pencerenin hemen oncesindeki ESIT UZUNLUKTA pencere.
 *
 * Bitis, secili araligin BASLANGICI (dahil degil gibi dusunulur): iki pencere
 * ust uste binmemeli, yoksa ayni islemler her iki donemde de sayilir ve kiyas
 * kendi kendini sulandirir.
 */
export const previousWindow = (start: Date, end: Date): { start: Date; end: Date } => {
  const from = start.getTime();
  const to = end.getTime();
  // Ters verilmis aralikta (bitis < baslangic) uzunluk 0 kabul edilir; negatif
  // uzunluk onceki pencereyi GELECEGE tasirdi.
  const length = Math.max(to - from, 0);
  return { start: new Date(from - length), end: new Date(from) };
};
